import {
  EventLogCourseFilter,
  EventLogTypesFilter,
  EventLogUserFilter
} from '.';

import type { Course, EventLogTypeGroup } from 'shared-types';
import type { UpdateEvents } from './EventLog';

interface Props {
  courses: Course[];
  onlyEventsOfType: EventLogTypeGroup;
  type: string | null;
  updateEvents: UpdateEvents;
  userSearch: boolean;
}

const EventLogHeader = ({
  courses,
  onlyEventsOfType,
  type,
  updateEvents,
  userSearch
}: Props) => (
  <div className="events-header">
    <div className="row row-center">
      <div className="col">
        {userSearch ? <EventLogUserFilter updateEvents={updateEvents} /> : null}
        {courses && courses.length ? (
          <div className="course-filter">
            <EventLogCourseFilter
              courses={courses}
              updateEvents={updateEvents}
            />
          </div>
        ) : null}
      </div>
      <div className="col-min">
        <div className="type-filter">
          <EventLogTypesFilter
            onlyEventsOfType={onlyEventsOfType}
            updateEvents={updateEvents}
          />
        </div>
      </div>
    </div>

    <style jsx>{`
      .course-filter {
        max-width: 300px;
      }
      .type-filter {
        text-align: right;
      }
    `}</style>
  </div>
);

export default EventLogHeader;
